'use strict';

const _ = require('underscore');
const i18n = require('i18next');
const Mn = require('backbone.marionette');
const Snackbar = require('common/util/snackbar');
const MarkdownWriterView = require('common/ui/view/markdown/writer');
const CommentService = require('feedback/app/service/idea/comment');
const CommentItemViewTemplate = require('feedback/ui/template/idea/comment/item.hbs');
const CommentFormViewTemplate = require('feedback/ui/template/idea/comment/form.hbs');
const CommentViewTemplate = require('feedback/ui/template/idea/comment/index.hbs');
const UserRequestCommentModel = require('feedback/domain/entity/comment');
const Marked = require('balus/util/marked');

/**
 * コメント 1件 ずつの表示
 */
const CommentItemView = Mn.View.extend({
    tagName: 'div',
    className: 'list-item comment-item',
    template: CommentItemViewTemplate,

    serializeData: function() {
        const json = this.model.toJSON();
        json['body'] = Marked()(json['body']);
        return json;
    }
});

const CommentListView = Mn.CollectionView.extend({
    childView: CommentItemView
});

/**
 * コメント投稿フォームの View
 */
const CommentFormView = Mn.View.extend({
    template: CommentFormViewTemplate,
    ui: {
        addButton: 'button.add',
        writer: '.input'
    },
    events: {
        'click @ui.addButton': 'addComment'
    },

    initialize: function() {
        this.model = new UserRequestCommentModel();

        _.bindAll(this, 'success', 'error');
    },

    submitButtonDisabled: function() {
        this.ui.addButton.addClass('disabled');
        this.ui.addButton.attr('disabled', true);
    },

    submitButtonEnabled: function() {
        this.ui.addButton.removeClass('disabled');
        this.ui.addButton.removeAttr('disabled');
    },

    onRender: function() {
        this.submitButtonDisabled();

        // markdown writer
        if (!this.$writer) {
            this.$writer = new MarkdownWriterView({
                markdown: this.model.get('body'),
                rows: 5
            });
            this.ui.writer.append(this.$writer.render().$el);
        }
        this.listenTo(this.$writer, 'change', function(desc){
            this.model.set('body', desc);
            if (desc.length == 0) {
                this.submitButtonDisabled();
            } else {
                this.submitButtonEnabled();
            }
        });

        return this;
    },

    addComment: function() {
        if (!this.model.isValid(true)) {
            return false;
        }
        this.submitButtonDisabled();
        this.ui.addButton.find('.fa').removeClass('hide');

        (new CommentService(
            this.getOption('idea'),
            this.model.toJSON()
        )).execute()
            .then(this.success, this.error);
    },

    success: function() {
        this.trigger('saved', this.model);
        this.$writer.clear();
        this.model.clear();
        Snackbar.info(i18n.t('notify.user_request.comment.save.success'));
    },

    error: function(model, xhr) {
        Snackbar.error(i18n.t('notify.user_request.comment.save.error'));
        Logger.error('UserRequestComment save failed', model, xhr);
        this.submitButtonEnabled();
    }
});

module.exports = Mn.View.extend({
    tagName: 'div',
    className: 'row',
    template: CommentViewTemplate,
    regions: {
        commentForm: '.comment-form',
        commentList: '.comment-list'
    },

    onRender: function() {
        this.showChildView('commentForm', new CommentFormView({
            idea: this.model
        }));

        this.showChildView('commentList', new CommentListView({
            collection: this.model.comments
        }));
    }
});



// WEBPACK FOOTER //
// ./feedback/ui/view/idea/comment.js